import { FC, SVGProps } from 'react';

const LockFilledIcon: FC<SVGProps<SVGSVGElement> & { size?: number }> = ({
  color = '#2d2d2d',
  size = 18,
  ...props
}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" {...props} fill="none">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.7733 6.82629C11.549 6.82329 11.303 6.82254 11.0218 6.82254H6.97781C6.69581 6.82254 6.44981 6.82329 6.22556 6.82629V5.61729C6.25106 4.10829 7.45406 2.91204 8.96452 2.89254H8.99903C10.5133 2.89254 11.7545 4.11354 11.7733 5.62329V6.82629ZM9.56235 12.3275C9.56235 12.638 9.31027 12.89 8.99985 12.89C8.68935 12.89 8.43735 12.638 8.43735 12.3275V10.7C8.43735 10.3895 8.68935 10.1375 8.99985 10.1375C9.31027 10.1375 9.56235 10.3895 9.56235 10.7V12.3275ZM14.6698 8.30902C14.4088 7.77052 13.9716 7.33554 13.4421 7.08579C13.2756 7.00479 13.0978 6.95079 12.8983 6.91179V5.61654C12.8713 3.46779 11.0976 1.72029 8.95035 1.76754C6.82781 1.79454 5.13656 3.47754 5.10056 5.60754V6.91179C4.90256 6.95004 4.72556 7.00329 4.56056 7.08354C4.02806 7.33479 3.59081 7.76977 3.32756 8.31127C3.07031 8.85352 3.07031 9.48052 3.07031 10.73V12.3275C3.07031 13.5838 3.07031 14.2145 3.32831 14.7463C3.58556 15.2878 4.01081 15.7138 4.56131 15.9815C5.09906 16.235 5.72681 16.235 6.97781 16.235H11.0218C12.2729 16.235 12.8998 16.235 13.4421 15.9793C13.9813 15.7168 14.417 15.2788 14.6691 14.7493C14.9293 14.2145 14.9293 13.5838 14.9293 12.3275V10.73C14.9293 9.48052 14.9293 8.85352 14.6698 8.30902Z"
        fill={color}
      />
    </svg>
  );
};

export default LockFilledIcon;
